.FileSelector {
  border: 1px dashed rgb(0, 0, 0, 0.2);
  border-radius: 1rem;
  padding: 1.5rem;

  min-width: 40rem;
  min-height: 10rem;
  height: 100%;
  width: 100%;

  cursor: pointer;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 1.5rem;

  .FileSelectorFooter {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    row-gap: 1.5rem;
  }
}

.Done {
  background-color: rgba(30, 190, 97, 0.3);
  border: none;
}
